import type IDMSCampaign from "./get-dms-campaigns-list.admin.http";
import { useGetHttp } from "../../http.hook";

interface IResponse {
  campaign: IDMSCampaign;
}

export function useGetDMSCampaignByIdAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/dms/campaigns/:dmsCampaignId",
  });
}
